import { RRIInputOption } from './input-option.interface';

export interface RRICheckboxOption<T> extends RRIInputOption<T> {}
